<div class="page-container">
  <div class="card p-3 m-3">
    <div class="row px-3 mb-2">
      <div class="mb-2 d-flex align-items-end gap-3">
        <h2 class="mb-0"><b>Storico Resi</b></h2>
      </div>

        <div class="d-flex flex-wrap gap-3 mb-3">
          <div class="mb-2">
            <input type="text" class="form-control" placeholder="Codice Reso" [(ngModel)]="searchPalletCode" />
          </div>
          <div class="mb-2">
            <input type="text" class="form-control" placeholder="Codice Bolla" [(ngModel)]="searchWaybillCode" />
          </div>
        </div>
        <div class="d-flex justify-content-end gap-2">
          <button class="btn btn-primary" (click)="applyFilters()">Cerca</button>
          <button class="btn btn-light" type="button" (click)="resetFilters()">Reset</button>
        </div>
    </div>
  </div>





    <div class="row px-3 mb-3">
      <div class="col-12 d-flex justify-content-end align-items-center gap-2 flex-wrap flex-md-nowrap">
        
        <!-- Bottone Excel -->
        <button class="btn btn-green"
                type="button"
                (click)="exportParcelsToExcel()"
                title="Esporta Excel">
          <i class="fas fa-file-excel"></i>
        </button>

        <!-- Select righe per pagina -->
        <select class="form-select"
                [(ngModel)]="itemsPerPage"
                (change)="onItemsPerPageChange()"
                style="width: auto;"
                title="Numero righe">
          <option [ngValue]="10">10</option>
          <option [ngValue]="25">25</option>
          <option [ngValue]="50">50</option>
          <option [ngValue]="100">100</option>
        </select>

        <!-- Bottone reset -->
        <button class="btn btn-primary"
                type="button"
                (click)="resetItemsPerPage()"
                title="Reset numero righe">
          <i class="fa fa-undo"></i>
        </button>
        
      </div>
    </div>


  <!-- Errore filtri -->
  <div *ngIf="dateError" class="alert alert-danger mx-3">
    {{ dateError }}
  </div>

  <!-- Tabella Colli -->
  <div *ngIf="!isLoading && oprPallets.length > 0">
  <div class="table-wrapper mx-3">
    <table class="table fixed-header-table table-hover">
      <thead class="bg-light">
        <tr>
          <th>Codice Reso</th>
          <th>Codice Bolla</th>
          <th>Data Affido</th>
          <th>Contenuto</th>
          <th>Codice Dealer</th>
          <th>Dealer</th>
          <th>Indirizzo Dealer</th>
          <th>Data consegna</th>
          <th>Data stimata</th>
          <th>Regione</th>
          <th>Codice spedizione</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let p of filteredOprPallets | paginate: { id: 'pallet-pagination', itemsPerPage: itemsPerPage, currentPage: currentPage }">
          <tr style="cursor: pointer;">
            <td>{{ p.palletCode }}</td>
            <td>{{ p.palletWaybillCode }}</td>
            <td>{{ p.palletDate | date: 'dd/MM/yyyy HH:mm' }}</td>
            <td>{{ p.palletDeliveryType }}</td>
            <td>{{ p.palletDealerCode }}</td>
            <td>{{ p.dealerName }}</td>
            <td>{{ p.dealerOperatingAddressStreet }} - {{ p.dealerOperatingAddressCity }}</td>
            <td>{{ p.palletStatus === 'DELIVERED' ? (p.palletActualDeliveryDate | date: 'dd/MM/yyyy HH:mm') : '' }}</td>
            <td>{{ p.palletEstimatedDeliveryDate | date: 'dd/MM/yyyy HH:mm' }}</td>
            <td>{{ p.regionName }}</td>
            <td>{{ p.palletShipmentCode }}</td>
          </tr>

          <!-- comPallets -->
          <tr>
            <td colspan="14" class="p-0">
              <div class="bg-light p-3 pt-0 rounded">
                <div class="timeline-wrapper d-flex flex-column ">

                  <ng-container *ngFor="let c of getFilteredPallets(p)">
                    <ng-container *ngIf="c.palletComplementaryValueNumber != null && c.palletComplementaryValueNumber !== ''">
                      <div class="step-row d-flex align-items-center p-2 bg-white shadow-sm flex-wrap flex-md-nowrap">

                        <!-- Icona + Step -->
                        <div class="d-flex align-items-center me-3 mb-2 mb-md-0 step-label">
                          <ng-container [ngSwitch]="c.palletComplementaryValueNumber">
                            <ng-container *ngSwitchCase="0">
                              <i class="fa-solid fa-clock text-orange fs-6 me-2"></i>
                              <span class="badge badge-orange me-2">0</span>
                              <strong>Pianificato</strong>
                            </ng-container>
                            <ng-container *ngSwitchCase="1">
                              <i class="fa-solid fa-handshake text-green fs-6 me-2"></i>
                              <span class="badge badge-green me-2">1</span>
                              <strong>Affidato</strong>
                            </ng-container>

                            <ng-container *ngSwitchCase="2">
                              <i class="fa-solid fa-truck-arrow-right text-green fs-6 me-2"></i>
                              <span class="badge badge-green me-2">2</span>
                              <strong>Ritirato dall’autista</strong>
                            </ng-container>

                            <ng-container *ngSwitchCase="3">
                              <i class="fa-solid fa-box-open text-green fs-6 me-2"></i>
                              <span class="badge badge-green me-2">3</span>
                              <strong>In magazzino</strong>
                            </ng-container>

                            <ng-container *ngSwitchCase="4">
                              <i class="fa-solid fa-dolly text-green fs-6 me-2"></i>
                              <span class="badge badge-green me-2">4</span>
                              <strong>Uscito magazzino</strong>
                            </ng-container>

                            <ng-container *ngSwitchCase="5">
                              <i class="fa-solid fa-warehouse text-green fs-6 me-2"></i>
                              <span class="badge badge-green me-2">5</span>
                              <strong>Consegnato</strong>
                            </ng-container>
                            <ng-container *ngSwitchCase="6">
                              <i class="fa-solid fa-calendar-check text-red fs-6 me-2"></i>
                              <span class="badge badge-red me-2">6</span>
                              <strong>Chiuso forzatamente</strong>
                            </ng-container>

                            <ng-container *ngSwitchDefault>
                              <i class="fa-solid fa-question-circle text-muted fs-6 me-2"></i>
                              <span class="badge bg-secondary me-2">{{ c.palletComplementaryValueNumber }}</span>
                              <strong class="text-muted">Stato non definito</strong>
                            </ng-container>
                          </ng-container>
                        </div>

                        <!-- Dati -->
                        <div class="d-flex flex-wrap flex-grow-1 gap-4 small-data">
                          <div style="min-width: 200px;"><strong>Data</strong><br>{{ c.palletComplementaryValueDate | date: 'dd/MM/yyyy HH:mm' }}</div>
                          <div style="min-width: 200px;"><strong>Inviato</strong><br>
                            <ng-container *ngIf="c.palletComplementaryStatus === 'SENT'; else showStatus">
                              <i class="fas fa-check" style="color: #259e15;"></i>
                            </ng-container>
                            <ng-template #showStatus>
                              {{ c.palletComplementaryStatus === 'INSERTED' || c.palletComplementaryStatus === 'CLOSED' ? '' : c.palletComplementaryStatus }}
                            </ng-template>
                          </div>
                          <div style="min-width: 200px;"><strong>Magazzino</strong><br>{{ c.warehouseCodeName }}</div>
                          <div style="min-width: 200px;"><strong>Vettore</strong><br>{{ c.carrierName }}</div>
                        </div>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
              </div>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>

  <div *ngIf="!isLoading && oprPallets.length === 0" class="mx-3">
    <div class="alert alert-warning d-flex align-items-center justify-content-between">
      <div>
        <i class="fas fa-exclamation-triangle me-2"></i>
        <span>Nessun reso trovato con i filtri selezionati.</span>
      </div>
      <!--tolto perché non applicava i filtri sopra -->
      <!-- <button class="action-btn primary" (click)="loadData()">
      <i class="fa fa-refresh me-1"></i>
      <span class="action-text">Riprova</span>
    </button> -->
    </div>
  </div>


  <!-- Pagination -->
  <pagination-controls id="pallet-pagination" [maxSize]="5" [autoHide]="true" [responsive]="true" previousLabel="←"
    nextLabel="→" class="d-flex justify-content-end mt-3" (pageChange)="onPageChange($event)">
  </pagination-controls>

</div>

<!-- Loader centrato -->
<div *ngIf="isLoading" class="loading-overlay">
  <div class="spinner-border text-primary" role="status" style="width: 4rem; height: 4rem;">
    <span class="visually-hidden">Caricamento...</span>
  </div>
</div>